import { CvaMarketingHeadingProps } from '../../types';
import { CatHeading } from '@blocks-react/components/Heading';

export const CvaMarketingHeading = ({
  className,
  children,
}: CvaMarketingHeadingProps) => {
  return (
    <CatHeading variant="title" className={className}>
      {children}
    </CatHeading>
  );
};
